import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import moment from 'moment'

import { planTypeForValue } from '_utils/planType'

import styles from '../styles.css'
import {
  reactTableProps,
  tableProps,
  theadGroupProps,
  theadGroupTrProps,
  theadGroupThProps,
  theadProps,
  theadTrProps,
  theadThProps,
  tBodyProps,
  trGroupProps,
  trProps,
  thProps,
  tdProps,
} from '../styles'

const INTERVAL_DURATION_TYPE = {
  100: 'Months',
  200: 'Years',
}

const columns = [
  {
    id: 'code',
    Header: 'Code',
    accessor: 'code',
  },
  {
    id: 'intervals',
    Header: 'Intervals',
    accessor: 'intervals',
  },
  {
    id: 'intervalType',
    Header: 'Interval Duration',
    accessor: a => INTERVAL_DURATION_TYPE[a.intervalDurationType],
  },
]

class ManageCodes extends PureComponent {
  static propTypes = {}

  static defaultProps = {
    codeList: [],
  }

  state = {
    codeList: [],
  }

  componentDidMount() {
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = ({ codeList }) => {
    this.setState({ codeList })
  }

  getTrProps = (state, rowInfo) => {
    return {}
  }

  filter = (filter, row, column) => {
    const id = filter.pivotId || filter.id
    if (row[id] !== undefined) {
      if (id === 'name' || id === 'email') {
        return String(row[id])
          .toLowerCase()
          .startsWith(filter.value.toLowerCase())
      } else {
        return +filter.value <= row[id]
      }
    }
    return true
  }

  render() {
    const { codeList } = this.state

    return (
      <ReactTable
        className={classnames(styles.ReactTable, '-highlight')}
        data={codeList}
        columns={columns}
        filterable
        defaultFilterMethod={this.filter}
        getProps={reactTableProps}
        getTableProps={tableProps}
        getTheadGroupProps={theadGroupProps}
        getTheadGroupTrProps={theadGroupTrProps}
        getTheadGroupThProps={theadGroupThProps}
        getTheadProps={theadProps}
        getTheadTrProps={theadTrProps}
        getTheadThProps={theadThProps}
        getTbodyProps={tBodyProps}
        getTrGroupProps={trGroupProps}
        getTrProps={this.getTrProps}
        getThProps={thProps}
        getTdProps={tdProps}
        showPageSizeOptions={false}
        defaultPageSize={20}
      />
    )
  }
}

export default ManageCodes



// WEBPACK FOOTER //
// ./src/views/admin/components/ManageCodes.js